import { colonSeparator } from "./consts";

export const cartProductRegexp = new RegExp(`^\\d+${colonSeparator}\\d+\\.?\\d*$`);
export const ipAddress = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/g;
